import { useState, useEffect } from 'react';
import { FaCheck, FaTrash, FaTimes, FaQuestion, FaPlus } from 'react-icons/fa';
import { getFingerprint } from '../services/fingerprint';
import { saveConfirmation, getConfirmation } from '../services/storage';
import { Bars } from 'react-loader-spinner'

const RSVP = () => {
  const [formData, setFormData] = useState({
    name: '',
    message: '',
    phone: '',
    companions: [],
    preWeddingAttendance: 'yes',
    weddingAttendance: 'yes',
    postWeddingAttendance: 'yes',
  });
  const [hasPrevConfirmed, setHasPrevConfirmed] = useState(false);
  const [submittedSuccess, setSubmittedSucess] = useState(false);
  const [submittedError, setSubmittedError] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [companions, setCompanions] = useState([]);
  const [companionInput, setCompanionInput] = useState('');
  const [fingerprint, setFingerprint] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initializeForm = async () => {
      try {
        const fp = await getFingerprint();
        setFingerprint(fp);

        if (fp) {
          const savedData = getConfirmation(`confirmation-${fp}`);
          if (savedData) {
            setFormData({
              id: savedData.id || '',
              name: savedData.name || '',
              message: savedData.message || '',
              food: savedData.food || '',
              phone: savedData.phone || '',
              companions: savedData.companions || [],
              preWeddingAttendance: savedData.preWeddingAttendance || null,
              weddingAttendance: savedData.weddingAttendance || null,
              postWeddingAttendance: savedData.postWeddingAttendance || null,
            });
            setCompanions(savedData.companions || []);
            setHasPrevConfirmed(true);
          }
        }
      } catch (error) {
        console.error('Error initializing form:', error);
      } finally {
        setIsLoading(false);
      }
    };

    initializeForm();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const addCompanion = () => {
    const trimmedInput = companionInput.trim();
    if (trimmedInput && !companions.includes(trimmedInput)) {
      setCompanions(prev => [...prev, trimmedInput]);
      setCompanionInput('');
      setFormData(prev => ({ ...prev, companions: [...prev.companions, trimmedInput] }))
    }
  };

  const removeCompanion = (companionToRemove) => {
    setCompanions(prev => prev.filter(companion => companion !== companionToRemove));
  };

  const handleCompanionKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addCompanion();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.name && formData.preWeddingAttendance && formData.weddingAttendance && formData.postWeddingAttendance) {
      setSubmitting(true);

      const dataToSubmit = {
        ...formData,
        fingerprint
      };

      setSubmitting(true)

      try {
        const response = await fetch('https://api.daniraquel.love/confirmation', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(dataToSubmit)
        })

        const data = await response.json()

        console.log({ ...formData, companions });
        
        if (fingerprint) {
          console.log('storing info in local storage');
          saveConfirmation(`confirmation-${fingerprint}`, { ...formData, id: data?.responseObject?.id });
        }
        
        setSubmitting(false);
        setSubmittedSucess(true)
        setTimeout(() => setSubmittedSucess(false), 4000)
      } catch (e) {
        setSubmitting(false)
        setSubmittedSucess(false)
        setSubmittedError(true)
        setTimeout(() => setSubmittedError(false), 15000)
      }
    }
  };

  if (isLoading) {
    return (
      <section className="py-16 px-4 bg-rose-50">
        <div className="max-w-2xl mx-auto">
          <h2 className="font-great-vibes text-4xl text-center text-rose-600 mb-8">Confirmación de asistencia</h2>
          <div className="bg-white p-6 rounded-lg shadow-md">
            <div className="flex justify-center items-center py-8">
              <div className="text-rose-600">Cargando...</div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 px-4 bg-rose-50">
      <div className="max-w-2xl mx-auto">
        <h2 className="font-great-vibes text-4xl text-center text-rose-600 mb-8">Confirmación de asistencia</h2>

        <p class="text-gray-700 mb-6">Te agradeceríamos que confirmases tu asistencia lo antes posible (tanto si vienes como si no). <br></br> <br></br> ¡No te olvides de anotar también a tus acompañantes!</p>

        <div className="bg-white p-6 rounded-lg shadow-md">
          {hasPrevConfirmed && (
            <div className="mb-6 p-4 bg-green-100 text-green-700 rounded-lg">
              <p>Hemos encontrado la confirmación que nos enviaste. Puedes actualizarla de nuevo si lo necesitas</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="name" className="block text-gray-700 mb-2">Tu nombre</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-400 focus:border-transparent"
                required
              />
            </div>

            <div>
              <label htmlFor="companionName" className="block text-gray-700 mb-2">Tus acompañantes (Opcional)</label>
              <div className="flex flex-wrap flex-start gap-2">
                <input
                  type="text"
                  id="companionName"
                  name="companionName"
                  value={companionInput}
                  onChange={(e) => setCompanionInput(e.target.value)}
                  onKeyPress={handleCompanionKeyPress}
                  className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-400 focus:border-transparent"
                />
                <button
                  type="button"
                  onClick={addCompanion}
                  className="px-4 py-2 bg-rose-500 text-white rounded-lg hover:bg-rose-600 transition-colors flex items-center gap-1"
                >
                  <FaPlus /> Añadir
                </button>
              </div>

              {companions.length > 0 && (
                <div className="mt-3 space-y-2">
                  {companions.map((companion, index) => (
                    <div
                      key={index}
                      className="flex items-center justify-between bg-rose-100 px-4 py-2 rounded-lg"
                    >
                      <span className="text-gray-700">{companion}</span>
                      <button
                        type="button"
                        onClick={() => removeCompanion(companion)}
                        className="text-rose-600 hover:text-rose-800 transition-colors"
                        aria-label="Eliminar acompañante"
                      >
                        <FaTrash />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div>
              <label className="block text-gray-700 mb-2">Pre-boda viernes 11 de Septiembre</label>
              <div className="w-full relative mt-5 sm:flex">
                {[
                  { displayValue: 'Sí asistiré', value: 'yes', icon: <FaCheck className="text-white inline ml-1 mb-1" /> },
                  { displayValue: 'No iré', value: 'no', icon: <FaTimes className="text-white inline ml-1 mb-1" /> },
                  { displayValue: 'Estoy en duda', value: 'doubt', icon: <FaQuestion className="text-white inline ml-1 mb-1" /> }
                ].map((option) => (
                  <div className="my-5 md:my-0">
                      <input
                        type="radio"
                        name="preWeddingAttendance"
                        id={`preWeddingAttendance-${option.value}`}
                        value={option.value}
                        checked={formData.preWeddingAttendance === option.value}
                        onChange={handleChange}
                        className="peer w-0"
                        required
                      />
                      <label for={`preWeddingAttendance-${option.value}`} class="peer-checked:font-semibold peer-checked:bg-rose-500 peer-checked:text-white p-3 ml-2 mr-2 rounded-lg cursor-pointer">{option.displayValue} {option.icon}</label>
                    </div>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-gray-700 mb-2">Boda sábado 12 de Septiembre</label>
              <div className="w-full relative mt-5 sm:flex">
                {[
                  { displayValue: 'Sí asistiré', value: 'yes', icon: <FaCheck className="text-white inline ml-1 mb-1" /> },
                  { displayValue: 'No iré', value: 'no', icon: <FaTimes className="text-white inline ml-1 mb-1" /> },
                  { displayValue: 'Estoy en duda', value: 'doubt', icon: <FaQuestion className="text-white inline ml-1 mb-1" /> }
                ].map((option) => (
                  <div className="my-5 md:my-0">
                    <input
                      type="radio"
                      name="weddingAttendance"
                      id={`weddingAttendance-${option.value}`}
                      value={option.value}
                      checked={formData.weddingAttendance === option.value}
                      onChange={handleChange}
                      className="peer w-0"
                      required
                    />
                    <label for={`weddingAttendance-${option.value}`} class="peer-checked:font-semibold peer-checked:bg-rose-500 peer-checked:text-white transition-color p-3 ml-2 mr-2 rounded-lg cursor-pointer">{option.displayValue} {option.icon}</label>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-gray-700 mb-2">Brunch domingo 13 de Septiembre</label>
              <div className="w-full relative mt-5 sm:flex">
                {[
                  { displayValue: 'Sí asistiré', value: 'yes', icon: <FaCheck className="text-white inline ml-1 mb-1" /> },
                  { displayValue: 'No iré', value: 'no', icon: <FaTimes className="text-white inline ml-1 mb-1" /> },
                  { displayValue: 'Estoy en duda', value: 'doubt', icon: <FaQuestion className="text-white inline ml-1 mb-1" /> }
                ].map((option) => (
                  <div className="my-5 md:my-0">
                    <input
                      type="radio"
                      name="postWeddingAttendance"
                      id={`postWeddingAttendance-${option.value}`}
                      value={option.value}
                      checked={formData.postWeddingAttendance === option.value}
                      onChange={handleChange}
                      className="peer w-0"
                      required
                    />
                    <label for={`postWeddingAttendance-${option.value}`} class="peer-checked:font-semibold peer-checked:bg-rose-500 peer-checked:text-white transition-color p-3 ml-2 mr-2 rounded-lg cursor-pointer">{option.displayValue} {option.icon}</label>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <label htmlFor="food" className="block text-gray-700 mb-2">Restricciones alimentarias: alergias, intolerancias (Opcional)</label>
              <input
                id="food"
                name="food"
                value={formData.food}
                onChange={handleChange}
                className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-400 focus:border-transparent"
              ></input>
            </div>

            <div>
              <label htmlFor="phone" className="block text-gray-700 mb-2">Tu teléfono (Opcional)</label>
              <input
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-400 focus:border-transparent"
              ></input>
            </div>

            <div>
              <label htmlFor="message" className="block text-gray-700 mb-2">Un mensajito cariñoso (Opcional)</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="3"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-400 focus:border-transparent"
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full py-3 bg-rose-500 text-white rounded-lg hover:bg-rose-600 transition-colors shadow-md"
            >
              { submitting ? (<Bars
                        height="30"
                        width="30"
                        color="white"
                        ariaLabel="bars-loading"
                        wrapperStyle={{}}
                        wrapperClass="justify-center"
                        visible={true}
                        />) : (hasPrevConfirmed ? 'Actualizar confirmación' : 'Enviar confirmación' )
              }
            </button>

            {submittedSuccess && (
              <div className="mb-6 p-4 bg-green-100 text-green-700 rounded-lg">
                {hasPrevConfirmed ? '¡Hemos actualizado tu confirmación de asistencia!' : 'Confirmación de asistencia enviada. ¡Muchas gracias!'}
              </div>
            )}
            
            {submittedError && (
              <div className="mb-6 p-4 bg-red-100 text-red-500 rounded-lg">
                {hasPrevConfirmed ? 
                  '¡Ha ocurrido un error al actualizar tu confirmación de asistencia! Intentalo de nuevo más tarde. Si el problema persiste, ponte en contacto con Dani o Raquel' 
                  : 
                  'Ha ocurrido un error al enviar tu confirmación. Intentalo de nuevo más tarde. Si el problema persiste, ponte en contacto con Dani o Raquel'
                }
              </div>
            )}
          </form>
        </div>

        <p class="text-gray-500 mt-4 mb-4"> Si cuando se vaya acercando la fecha, hay cambios en la asistencia que nos enviaste, no te preocupes..puedes volver a enviarla usando este formulario nuevamente.</p>
      </div>
    </section>
  );
};

export default RSVP;
